import { BadToGood, useCannectCare } from 'hooks/useCannectCare'
import { HorizontalContent } from 'pages/CannectCare/styles'
import DeactivatableButton from '../../DeactivatableButton'
import Question from '../Question'

export default function LocomotionAssessment() {
  const { setStep, locomotionAbility, setLocomotionAbility } = useCannectCare()

  function handleOptionChoice(id: string) {
    setLocomotionAbility(id as BadToGood)
  }

  return (
    <>
      <span>Veja o que você acha e selecione a que lhe parece a melhor resposta</span>
      <Question
        title="Quão bem você é capaz de se locomover?"
        // eslint-disable-next-line react/jsx-no-bind
        onOptionChoice={handleOptionChoice}
        options={[
          {
            id: 'veryBad',
            labelId: 'veryBad',
            label: 'muito mal',
            checked: locomotionAbility === 'veryBad'
          },
          {
            id: 'bad',
            labelId: 'bad',
            label: 'mal',
            checked: locomotionAbility === 'bad'
          },
          {
            id: 'neitherBadNorGood',
            labelId: 'neitherBadNorGood',
            label: 'nem mal, nem bem',
            checked: locomotionAbility === 'neitherBadNorGood'
          },
          {
            id: 'good',
            labelId: 'good',
            label: 'bem',
            checked: locomotionAbility === 'good'
          },
          {
            id: 'veryGood',
            labelId: 'veryGood',
            label: 'muito bem',
            checked: locomotionAbility === 'veryGood'
          }
        ]}
      />
      <HorizontalContent style={{ justifyContent: 'space-between' }}>
        <DeactivatableButton outlined onClick={() => setStep((state) => state - 1)}>
          Voltar
        </DeactivatableButton>
        <DeactivatableButton onClick={() => setStep((state) => state + 1)} disabled={locomotionAbility === ''}>
          Próximo
        </DeactivatableButton>
      </HorizontalContent>
    </>
  )
}
